import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  guidelineCard: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '2.4rem 4rem',
    marginBottom: '4rem',
  },
  productLineNameWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  cardHeaderName: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: '500',
      color: colors.neutral[700],
    },
    letterSpacing: '0.05rem',
    paddingBottom: '1.6rem',
    textAlign: 'center',
    borderBottom: '0.1rem solid #C1C7CD',
    textTransform: 'uppercase',
    width: '100%',
  },
  collapsedSection: {
    paddingBottom: 0,
    borderBottom: 'none',
  },
  productLineName: {
    marginLeft: '0.5rem',
    fontWeight: '700',
  },
  productLineRulesBlock: {
    marginTop: '3.6rem',
  },
  guidelineRulesBlock: {
    marginTop: '1.6rem',
  },
  ruleName: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: '700',
      color: colors.neutral[900],
    },
    letterSpacing: '0.02rem',
  },
  ruleText: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: '400',
      color: colors.neutral[900],
    },
    letterSpacing: '0.02rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
